import { ReactElement } from 'react';

import {
  Button,
  Typography,
} from '@beeline/design-system-react/extracted-styles';

import { ErrorImage } from ':components/ErrorImage';

import styles from './styles.module.scss';

export function ErrorComponent({
  refetch,
}: {
  refetch: () => void;
}): ReactElement {
  return (
    <div className={styles.errorBlock}>
      <div className={styles.contentBlock}>
        <ErrorImage />
        <Typography variant='h6'>
          Не удалось загрузить список сервисов
        </Typography>
        <Button size='medium' variant='plain' onClick={refetch}>
          Попробовать снова
        </Button>
      </div>
    </div>
  );
}
